import React from 'react'

const Playground = () => {
  return (
    <div className="playground-page">
      <style>{`
        .playground-page {
          --font: 2rem;
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 24px;
          background-color: rgba(0, 0, 0, 0.3);
        }

        .playground-page h1 {
          color: white;
          margin: 0;
          position: relative;
          top: 1rem;
          font-style: italic;
        }

        .playground-page button {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          border: none;
          font-family: 'Open Sans', sans-serif;
          font-size: var(--font);
          border-radius: calc(var(--font) * 0.6);
          padding: calc(var(--font) * 0.5);
          margin: 0;
          line-height: 1;
          position: relative;
          background-color: transparent;
          color: white;
          box-shadow: inset 0 0 0 0 rgb(248 249 255 / 0.5), inset 0 0 0 0 rgb(248 249 255 / 0.3), 0 0 0 rgb(248 249 255 / 0.2);
          transition: all ease 0.2s;
        }

        .playground-page button:hover {
          box-shadow: inset 0 0 0 calc(var(--font) * 0.2) rgb(248 249 255 / 0.5), inset 0 0 calc(var(--font) * 0.2) calc(var(--font) * 0.5) rgb(248 249 255 / 0.3), 0 0 calc(var(--font) * 0.2) rgb(248 249 255 / 0.2);
        }

        .playground-page button::before {
          content: '';
          height: 110%;
          width: 105%;
          position: absolute;
          border-radius: calc(var(--font) * 0.8);
          background-color: transparent;
        }

        @keyframes borders {
          0%,
          100% {
            border-width: calc(var(--font) * 0.2) calc(var(--font) * 0.1) calc(var(--font) * 0.02) calc(var(--font) * 0.02);
          }

          25% {
            border-width: calc(var(--font) * 0.1) calc(var(--font) * 0.02) calc(var(--font) * 0.02) calc(var(--font) * 0.2);
          }

          50% {
            border-width: calc(var(--font) * 0.02) calc(var(--font) * 0.02) calc(var(--font) * 0.2) calc(var(--font) * 0.1);
          }

          75% {
            border-width: calc(var(--font) * 0.02) calc(var(--font) * 0.2) calc(var(--font) * 0.1) calc(var(--font) * 0.02);
          }
        }

        .playground-page button:hover::before {
          border: solid rgb(210 255 227 / 0.8);
          padding: calc(var(--font) * 0.08);
          box-shadow: inset 0 0 calc(var(--font) * 0.2) calc(var(--font) * 0.2) rgb(186 201 255 / 0.3);
          filter: blur(calc(var(--font) * 0.06));
          animation: borders infinite 2s linear;
          opacity: 0.5;
        }

        .playground-page .button-glow {
          height: 100%;
          width: 100%;
          position: absolute;
          overflow: hidden;
          display: flex;
          border-radius: calc(var(--font) * 0.6);
          z-index: -1;
        }

        .playground-page .button-glow::after {
          content: '';
          height: 100%;
          width: 100%;
          position: absolute;
          background: linear-gradient(90deg, rgb(248 249 255 / 0), rgb(206 216 255 / 0.6), rgb(248 249 255 / 0));
          opacity: 0;
          transform: translateX(-100%);
        }

        .playground-page button:hover > .button-glow::after {
          opacity: 1;
          transform: translateX(100%);
          transition: all ease 1s;
        }

        .playground-page .play-button-container {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: fit-content;
          border-radius: 1rem;
          padding: 1rem;
          background-color: rgba(0, 0, 0, 0.2);
          backdrop-filter: blur(50px);
          -webkit-backdrop-filter: blur(50px);
        }

        .playground-page .play-button {
          --font: 3rem;
          font-weight: 700;
          color: black;
          border-radius: 4rem;
          height: 12rem;
          width: min(25rem, 100%);
          box-shadow: inset 0 0 0 0 rgb(248 249 255 / 0.5);
          border: 1rem solid transparent;
          position: relative;
        }

        .playground-page .play-button:hover::before {
          opacity: 0.2;
          border-radius: 4rem;
        }

        .playground-page .play-button > .button-glow {
          background-color: rgb(247, 255, 25);
          height: 8rem;
          width: 21rem;
          border-radius: 2rem;
        }

        .playground-page .play-button > .button-glow::after {
          display: none;
        }

        .playground-page .play-button:hover {
          box-shadow: inset 0 0 0 calc(var(--font) * 0.15) rgb(248 249 255 / 0.6);
        }

        @media (max-width: 640px) {
          .playground-page .play-button {
            --font: 2rem;
            height: 9rem;
            width: min(20rem, 100%);
            border-width: 0.75rem;
          }

          .playground-page .play-button > .button-glow {
            height: 6rem;
            width: calc(100% - 2rem);
          }
        }
      `}</style>

      <div className="play-button-container">
        <button type="button" className="play-button">
          Играть
          <span className="button-glow" aria-hidden="true" />
        </button>
      </div>
    </div>
  )
}

export default Playground
